import apiRequestV2 from 'libraries/api-v2/api';

const basePath = '/web-api';

export const getClients = () => apiRequestV2('get', `${basePath}/clients`).then(res => res.data);

export default {
  getClients,
};
